import { render, staticRenderFns } from "./editRace.vue?vue&type=template&id=12154a6c&scoped=true"
import script from "./editRace.vue?vue&type=script&lang=js"
export * from "./editRace.vue?vue&type=script&lang=js"
import style0 from "./editRace.vue?vue&type=style&index=0&id=12154a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12154a6c",
  null
  
)

export default component.exports